import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import { LazyMotion, domAnimation } from 'framer-motion';
import App from './App';
import { darkTheme } from './theme';

const globalStyles = (
  <GlobalStyles
    styles={{
      '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      },
      html: {
        scrollBehavior: 'smooth',
        WebkitTextSizeAdjust: '100%',
      },
      body: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        overflowX: 'hidden',
      },
      'img, picture, video, canvas, svg': {
        display: 'block',
        maxWidth: '100%',
      },
      'input, button, textarea, select': {
        font: 'inherit',
      },
      'a': {
        textDecoration: 'none',
        color: 'inherit',
      },
      'ul, ol': {
        listStyle: 'none',
      },
      '::selection': {
        backgroundColor: 'rgba(245, 166, 35, 0.3)',
        color: 'inherit',
      },
      '::-webkit-scrollbar': {
        width: '10px',
      },
      '::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(245, 166, 35, 0.5)',
        borderRadius: '5px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(245, 166, 35, 0.7)',
      },
    }}
  />
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {globalStyles}
      <LazyMotion features={domAnimation} strict>
        <App />
      </LazyMotion>
    </ThemeProvider>
  </StrictMode>
);
